export const START_CONSULTA = 'START_CONSULTA'
export const LIMPA_CONSULTA = 'LIMPA_CONSULTA'
export const REINICIA_CONSULTA = 'REINICIA_CONSULTA'
export const ATUALIZA_ESCOLHA = 'ATUALIZA_ESCOLHA'
export const ATUALIZA_MODALIDADE_ATENDIMENTO = 'ATUALIZA_MODALIDADE_ATENDIMENTO'
export const ATUALIZA_NUMERO_REQUISICAO = 'ATUALIZA_NUMERO_REQUISICAO'
export const ATUALIZA_CONFIRMACAO = 'ATUALIZA_CONFIRMACAO'
export const ATUALIZA_ORIGEM_TELECONSULTA = 'ATUALIZA_ORIGEM_TELECONSULTA'
export const ATUALIZA_LOCAL_SUGESTOES = 'ATUALIZA_LOCAL_SUGESTOES'
export const LIMPA_LOCAL_SUGESTOES = 'LIMPA_LOCAL_SUGESTOES'
export const ATUALIZA_FALLBACK_PERMITIDO = 'ATUALIZA_FALLBACK_PERMITIDO'
export const LIMPA_FALLBACK_PERMITIDO = 'LIMPA_FALLBACK_PERMITIDO'
export const DEFINE_METADATA = 'DEFINE_METADATA'
export const JA_LISTOU_HORARIO = 'JA_LISTOU_HORARIO'
